module.exports = __webpack_public_path__ + "static/img/pd_top_5.3674992.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_top_5.jpg
// module id = uyJK
// module chunks = 52